export interface OrderNotificationResponse {
  contactByEmail: boolean;
  contactByText: boolean;
  email: string[];
  phone: string;
  hasPromotions: boolean;
  hasIndustryUpdates: boolean;
  hasShipTos: boolean;
  subscribed: boolean;
  isAccessDenied: boolean;
  optedOutWarning: string;
  subscriptionType: OrderNotificationSubscriptionType;
  shipToSettings: ShipToSettingModel[];
  subscriptionSettings: OrderNotificationSubscriptionSettingModel[];
}

export interface OrderNotificationSettingRequest {
  subscribed: boolean;
  optedOutWarning?: string;
  hasPromotions: boolean;
  hasIndustryUpdates: boolean;

  contactByEmail: boolean;
  contactByText: boolean;
  email: string[];
  phone: string;

  subscriptionType: OrderNotificationSubscriptionType;
  subscriptionSettings: OrderNotificationSubscriptionSettingModel[];
  shipToSettings: ShipToSettingModel[];
}

export enum OrderNotificationSubscriptionType {
  RecommendedNotifications = "RecommendedNotifications",
  DailySummary = "DailySummary",
  EachOrder = "EachOrder",
}

export enum OrderNotificationFrequencyType {
  EachOrder = "EachOrder",
  DailySummary = "DailySummary",
  MonthlySummary = "MonthlySummary",
  OutForDelivery = "OutForDelivery",
  DeliveryComplete = "DeliveryComplete",
  DailyDelivery = "DailyDelivery",
  OneMonthToCancel = "OneMonthToCancel",
  TwoWeeksToCancel = "TwoWeeksToCancel",
  Cancelled = "Cancelled",
}

export enum OrderNotificationPreferenceType {
  Acknowledgements = "Acknowledgements",
  OrderReady = "OrderReady",
  DeliveryStatus = "DeliveryStatus",
  Cancellations = "Cancellations",
}

export interface ShipToSettingModel {
  shipTo: string;
  shipToName: string;
}

export interface OrderNotificationSubscriptionSettingModel {
  notificationType: OrderNotificationPreferenceType;
  isEmailMethod: boolean;
  isPhoneMethod: boolean;
  frequency: OrderNotificationFrequencyType;
}
